import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { Section, SectionHeader, Eyebrow, Lead } from './ui/Section';

// `embedded` renders it as a section of the landing page (h2); otherwise it is the body of /features (h1).
const Features = ({ embedded = false }) => {
  const { featuresTitle, featuresDesc, featuresList, featuresFooter } = useContext(LanguageContext);

  return (
    <Section tone="light" id="features">
      {embedded ? (
        <SectionHeader title={featuresTitle} lead={featuresDesc} />
      ) : (
        <div className="max-w-3xl">
          <Eyebrow>WashWorth</Eyebrow>
          <h1 className="mb-0 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-navy md:text-6xl">
            {featuresTitle}
          </h1>
          <Lead>{featuresDesc}</Lead>
        </div>
      )}

      <div
        className={`mt-12 grid gap-px overflow-hidden rounded-2xl border border-brand-line bg-brand-line md:grid-cols-2 ${
          featuresList.length % 3 === 0 ? 'lg:grid-cols-3' : ''
        }`}
      >
        {featuresList.map((feature, index) => (
          <div key={index} className="bg-white p-8">
            {React.cloneElement(feature.icon, { className: 'mb-6 h-6 w-6 text-brand-teal' })}
            <h3 className="mb-2 font-display text-lg font-bold text-brand-navy">{feature.title}</h3>
            <p className="mb-0 leading-relaxed text-slate-600">{feature.desc}</p>
          </div>
        ))}
      </div>

      {featuresFooter && <p className="mb-0 mt-8 text-sm text-slate-500">{featuresFooter}</p>}
    </Section>
  );
};

export default Features;
